import { Grid, TextField } from '@mui/material';
import { NumericTextField } from '../../../../components/NumericTextField';
import { useLpkRunContext as useContext } from './lpk-run-context';

export function Select({ options, children, renderValue, ...props }) {
  return (
    <Input select renderValue={renderValue} {...props}>
      {options || children}
    </Input>
  );
}

export function NumericInput(props) {
  return <Input ignoreNonNumericInput numeric {...props} />;
}

function Input({ numeric, name, renderValue, ...passThrough }) {
  const Component = numeric ? NumericTextField : TextField;
  const { getError, getParam, updateParam } = useContext();

  return (
    <Grid item sx={{ pt: 3, width: '100%' }}>
      <Component
        size="small"
        InputLabelProps={{ shrink: true }}
        inputProps={{ autoComplete: 'off' }}
        fullWidth
        name={name}
        value={getParam(name)}
        error={Boolean(getError(name))}
        helperText={getError(name)}
        onChange={(e) => updateParam(e.target.name, e.target.value)}
        SelectProps={{
          multiple: passThrough.multiple,
          ...(renderValue && { renderValue }),
        }}
        {...passThrough}
      />
    </Grid>
  );
}
